const normalizeExistingMoneyValue = (value) => {
  if (value === null || value === undefined) return ''

  if (typeof value === 'number') {
    if (!Number.isFinite(value)) return ''

    return Math.trunc(value).toString()
  }

  const rawValue = value.toString().trim()
  if (!rawValue) return ''

  if (/^[+-]?\d+(?:\.\d+)?[eE][+-]?\d+$/.test(rawValue)) {
    const scientificValue = Number(rawValue)
    if (Number.isFinite(scientificValue)) return Math.trunc(scientificValue).toString()
  }

  const decimalMatch = rawValue.match(/^([0-9]{4,})[.,]([0-9]{1,2})$/)
  if (decimalMatch) return decimalMatch[1]

  return rawValue.replace(/\D/g, '')
}

export const sanitizeThousandsInput = (value) => {
  const digits = normalizeExistingMoneyValue(value)
  if (!digits) return ''

  return digits.replace(/^0+(?=\d)/, '')
}

export const formatThousandsInput = (value) => {
  const digits = sanitizeThousandsInput(value)
  if (!digits) return ''

  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
